import React, { ComponentType } from 'react';
import AccessDeniedModal from '../components/AccessDeniedModal';

function withRoleAccess<P extends object>(WrappedComponent: ComponentType<P>, allowedRoles: string[]) {
  return class extends React.Component<P, { showModal: boolean }> {
    state = {
      showModal: false
    };

    componentDidMount() {
      const role = localStorage.getItem('role');
      if (!role || !allowedRoles.includes(role)) {
        this.setState({ showModal: true });
      }
    }

    handleClose = () => {
      this.setState({ showModal: false });
    };

    render() {
      if (allowedRoles.includes(localStorage.getItem('role') || '')) {
        return <WrappedComponent {...this.props as P} />;
      } else {
        return <AccessDeniedModal isOpen={this.state.showModal} onClose={this.handleClose} />;
      }
    }
  };
}

export default withRoleAccess;
